export const createError = (message: string, status?: number) => ({ message, status });
